<template>
  <el-dialog
    :title="dialogTitle"
    :width="dialogWidth"
    :top="dialogTop"
    :visible.sync="visible"
    class="custom-dialog"
    :modal-class="'custom-modal'"
    @close="handleClose"
  >
    <slot></slot>
    <template #footer v-if="!onlyCloseBtn">
      <el-button @click="visible = false">取消</el-button>
      <el-button
        type="primary"
        @click="throttledConfirmFn"
        :disabled="isConfirming || confirmDisabled"
      >确认</el-button>
    </template>
    <template #footer v-else>
      <el-button @click="visible = false" type="primary">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  name: 'ButtonDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: '提示'
    },
    dialogWidth: {
      type: String,
      default: '40%'
    },
    dialogTop: {
      type: String,
      default: '15vh'
    },
    onlyCloseBtn: {
      type: Boolean,
      default: false
    },
    // 确认按钮禁用状态
    confirmDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'confirm'],
  data () {
    return {
      isConfirming: false,
      throttledConfirmFn: null
    }
  },
  computed: {
    visible: {
      get () {
        return this.modelValue !== undefined ? this.modelValue : this.dialogFormVisible
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      console.log('ButtonDialog: modelValue changed to', newVal)
    }
  },
  created () {
    // 创建带状态管理的节流函数
    this.throttledConfirmFn = throttle(() => {
      this.isConfirming = true
      this.$emit('confirm')
      setTimeout(() => {
        this.isConfirming = false
      }, 500)
    }, 500, { leading: true, trailing: false })
  },
  beforeUnmount () {
    // 清理节流函数
    if (this.throttledConfirmFn) {
      this.throttledConfirmFn.cancel()
    }
  },
  methods: {
    handleClose () {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.el-button:disabled {
  position: relative;
}
.el-button:disabled{
  opacity: 0.4;
}
</style>
